import { on } from "@ngrx/store";
import { DrawingActions } from "./drawing.actions";
import { PagesStore } from "../../pages.state";

const loadDrawingSuccess = on(
    DrawingActions.loadDrawingSuccess,
    DrawingActions.sendForDrawingSuccess,
    DrawingActions.startDrawingSuccess,
    DrawingActions.completeDrawingSuccess,
    DrawingActions.revokeDrawingSuccess,
    (state: PagesStore, { drawing }) => ({
        ...state,
        quote: { ...state.quote, drawing },
    }),
);

const uploadAttachmentStart = on(
    DrawingActions.uploadAttachment,
    (state: PagesStore, { tempId, kind, file }) => ({
        ...state,
        quote: {
            ...state.quote,
            drawingUploads: [...state.quote.drawingUploads, { tempId, kind, fileName: file.name, progress: 0 }],
        },
    }),
);

const uploadAttachmentProgress = on(
    DrawingActions.uploadAttachmentProgress,
    (state: PagesStore, { tempId, progress }) => ({
        ...state,
        quote: {
            ...state.quote,
            drawingUploads: state.quote.drawingUploads.map(u => u.tempId === tempId ? { ...u, progress } : u),
        },
    }),
);

const uploadAttachmentSuccess = on(
    DrawingActions.uploadAttachmentSuccess,
    (state: PagesStore, { tempId, attachment }) => ({
        ...state,
        quote: {
            ...state.quote,
            drawingUploads: state.quote.drawingUploads.filter(u => u.tempId !== tempId),
            drawing: state.quote.drawing
                ? { ...state.quote.drawing, attachments: [...(state.quote.drawing.attachments ?? []), attachment] }
                : state.quote.drawing,
        },
    }),
);

const uploadAttachmentFailure = on(
    DrawingActions.uploadAttachmentFailure,
    (state: PagesStore, { tempId }) => ({
        ...state,
        quote: {
            ...state.quote,
            drawingUploads: state.quote.drawingUploads.filter(u => u.tempId !== tempId),
        },
    }),
);

const deleteAttachmentSuccess = on(
    DrawingActions.deleteAttachmentSuccess,
    (state: PagesStore, { attachmentId }) => ({
        ...state,
        quote: {
            ...state.quote,
            drawing: state.quote.drawing
                ? { ...state.quote.drawing, attachments: (state.quote.drawing.attachments ?? []).filter(a => a.id !== attachmentId) }
                : state.quote.drawing,
        },
    }),
);

const reset = on(
    DrawingActions.reset,
    (state: PagesStore) => ({
        ...state,
        quote: { ...state.quote, drawing: undefined },
    }),
);

export const drawingReducer = [
    loadDrawingSuccess,
    uploadAttachmentStart,
    uploadAttachmentProgress,
    uploadAttachmentSuccess,
    uploadAttachmentFailure,
    deleteAttachmentSuccess,
    reset,
];
